<template>
  <div class="pmt-chips">
    <span
      v-for="p in pmts"
      :key="p.id"
      class="pmt-chip"
      :style="chipStyle(p.id)"
      :data-method-id="p.id"
    >
      <span class="pmt-dot" :style="dotStyle(p.id)"></span>
      <span class="pmt-nm">{{ p.name }}</span>
      <b>{{ formatNumber(p.amount) }}</b>
    </span>
  </div>
</template>

<script>
const COLORS = {
  1: { bg: "#e8f7ee", fg: "#1f7a48", dot: "#22a35a" },
  2: { bg: "#fff3e0", fg: "#a05a17", dot: "#e08a2c" },
  3: { bg: "#eaf1fe", fg: "#1a4ec0", dot: "#2a6df4" },
  4: { bg: "#f3e8fd", fg: "#5b21b6", dot: "#8b5cf6" },
  5: { bg: "#fde8ee", fg: "#a01a3c", dot: "#e0457b" },
};
const FALLBACK = { bg: "#eef1f5", fg: "#4a5568", dot: "#8a96a3" };

export default {
  name: "PaymentChips",
  props: {
    pmts: { type: Array, default: () => [] },
  },
  methods: {
    color(id) {
      return COLORS[id] || FALLBACK;
    },
    chipStyle(id) {
      const c = this.color(id);
      return { background: c.bg, color: c.fg };
    },
    dotStyle(id) {
      return { background: this.color(id).dot };
    },
    formatNumber(v) {
      return (Number(v) || 0).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
.pmt-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: flex-start;
  text-align: left;
}
.pmt-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.pmt-chip b {
  font-family: "IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
  font-weight: 600;
}
.pmt-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  display: inline-block;
  flex-shrink: 0;
}
.pmt-nm {
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
